import { ChatTexts } from './types'

export const DEFAULT_TEXTS: ChatTexts = {
  messages: {
    greeting: 'How can I help you book an appointment?',
  },
  welcome: {
    message: 'Welcome back, {firstName}!',
    messageWithEmail: 'Welcome back, {firstName}! ({email})',
    notMeButtonLabel: 'Not me',
  },
  input: {
    placeholder: 'Type a message...',
  },
  error: {
    generic: 'Something went wrong. Please try again.',
  },
  accessibility: {
    openChat: 'Open chat',
    closeChat: 'Close chat',
  },
  rating: {
    prompt: 'How was your experience?',
    commentPlaceholder: 'Leave a comment (optional)',
    submitButton: 'Submit',
    thankYou: 'Thank you for your feedback!',
  },
}

export const getTranslatedTexts = (t: (key: string) => string): ChatTexts => ({
  messages: {
    greeting: t(DEFAULT_TEXTS.messages.greeting),
  },
  welcome: {
    message: t(DEFAULT_TEXTS.welcome.message),
    messageWithEmail: t(DEFAULT_TEXTS.welcome.messageWithEmail),
    notMeButtonLabel: t(DEFAULT_TEXTS.welcome.notMeButtonLabel),
  },
  input: {
    placeholder: t(DEFAULT_TEXTS.input.placeholder),
  },
  error: {
    generic: t(DEFAULT_TEXTS.error.generic),
  },
  accessibility: {
    openChat: t(DEFAULT_TEXTS.accessibility.openChat),
    closeChat: t(DEFAULT_TEXTS.accessibility.closeChat),
  },
  rating: {
    prompt: t(DEFAULT_TEXTS.rating.prompt),
    commentPlaceholder: t(DEFAULT_TEXTS.rating.commentPlaceholder),
    submitButton: t(DEFAULT_TEXTS.rating.submitButton),
    thankYou: t(DEFAULT_TEXTS.rating.thankYou),
  },
})
